import getPageThreshold from "./getPageThreshold"

type TriangleRange = {
  start: number
  end: number
}

const getRanges = (
  maxTriangles: number,
  footerHeight: number
): TriangleRange[] => {
  const arr = []
  let startPoint = 0
  for (let i = 0; i < maxTriangles + 1; i++) {
    let endPoint = getPageThreshold(maxTriangles, footerHeight) * (i + 1)
    arr.push({
      start: startPoint,
      end: endPoint,
    })
    startPoint = endPoint
  }
  return arr
}

export default getRanges
